
























import { defineComponent, onMounted, ref, inject } from '@vue/composition-api'
import QRCode from 'qrcode'
import Steppers from '../components/parts/Steppers.vue'
import Button from '../components/parts/Button.vue'
import { key } from '../store'

export default defineComponent({
  components: {
    Steppers,
    Button,
  },
  setup() {
    const store = inject(key)
    if (!store) {
      throw new Error('')
    }
    let qrcodeCanvas = ref<HTMLCanvasElement | null>(null)
    function qrGenerate(data: string) {
      qrcodeCanvas.value = document.getElementById('qrcode') as HTMLCanvasElement
      return QRCode.toCanvas(qrcodeCanvas.value, data, {})
    }
    onMounted(() => {
      qrGenerate(store.state.blocks)
    })
  },
})
